import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { mdiAlertCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";

import Button from "components/Button";
import { routes } from "constants/routes";
import { AppDispatch } from "store";
import { getICOnboardingInformation } from "store/user/actions";
import { selectOnboardingInformation } from "store/user/selector";
import styles from "./style.module.scss";

type OnboardingIntroProps = {
  handleNext: (step: number) => void;
};

export default function OnboardingIntro({ handleNext }: OnboardingIntroProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { inviteToken } = useParams();
  const onboardingInformation = useSelector(selectOnboardingInformation);

  function goToHome() {
    navigate(routes.SIGNIN);
  }

  useEffect(() => {
    dispatch(getICOnboardingInformation(inviteToken ?? ""));
  }, []);

  if (onboardingInformation === undefined) return null;
  if (onboardingInformation.relationship_id) {
    navigate(routes.SIGNIN, { state: { email: onboardingInformation.email } });
  }

  return onboardingInformation ? (
    <div className={styles.page}>
      <span className="text-lg text-center desktop:text-3xl">
        Please continue to register for {onboardingInformation.group_name} group to create your
        payment profile to receive payments.
      </span>

      <Button
        rounded
        className="w-full desktop:w-1/2 desktop:h-16"
        onClick={() => handleNext(onboardingInformation?.relationship_id ? 2 : 1)}>
        Continue
      </Button>
    </div>
  ) : (
    <div className={styles.expiredWrapper}>
      <div className={styles.expiredLink}>
        <Icon path={mdiAlertCircleOutline} />
        <span>Link has expired</span>
      </div>
      <Button
        type="button"
        rounded
        className="!h-12 desktop:!w-40 !w-1/2 mx-auto"
        onClick={goToHome}>
        Go Back Home
      </Button>
    </div>
  );
}
